export default __webpack_public_path__ + "static/media/React.44319306.png";